import { appManager, AppState } from '../manager';
import * as types from '../types';
import { makeAPIProp, makeAPIPropByTenor } from 'services/indexedObject';
import {
  CurrentDepos,
  CurrentLoans,
  FutureDepos,
  FutureLoans,
  PastDepos,
  PastLoans,
  ReceiveClientCards,
} from './types';
import { LoanRateOfferOptions } from '../types';

export const fetchClientMoney = appManager.createApi<
  { session_id: number },
  ReceiveClientCards,
  AppState
>('GET_CLIENT_LOANS', {
  path: '/client_money/get_client_loans_depos',
  method: 'POST',
  startReducer(state) {
    state.client_money.fetching = true;
    state.client_money.fetched = false;
  },
  successReducer(state, result) {
    // console.log('client_money: ', result);
    state.client_money.current_loans = makeAPIPropByTenor(result.current_loans);
    state.client_money.past_loans = makeAPIPropByTenor(result.past_loans);
    state.client_money.future_loans = makeAPIPropByTenor(result.future_loans);

    state.client_money.current_depos = makeAPIPropByTenor(result.current_depos);
    state.client_money.past_depos = makeAPIPropByTenor(result.past_depos);
    state.client_money.future_depos = makeAPIPropByTenor(result.future_depos);

    state.client_money.lombard_rate = result.lombard_rate;

    state.client_money.fetched = true;
    state.client_money.fetching = false;
  },
  failReducer(state) {
    state.client_money.fetching = false;
    state.client_money.fetched = false;
  },
});

export const updateLoanRates = appManager.createApi<
  {
    loan_rates: { [key: number]: FutureLoans };
    player_id: number;
  },
  { updated_future_loan_cards: FutureLoans[] },
  AppState
>('UPDATE_LOANS_RATES', {
  path: '/client_money/update_loan_rates',
  method: 'POST',
  successReducer(state, result) {
    state.client_money.future_loans = makeAPIPropByTenor(
      result.updated_future_loan_cards
    );
  },
});

export const updateDepoRates = appManager.createApi<
  {
    depo_rates: { [key: number]: FutureDepos };
    player_id: number;
  },
  { updated_future_depo_cards: FutureDepos[] },
  AppState
>('UPDATE_DEPOS_RATES', {
  path: '/client_money/update_depo_rates',
  method: 'POST',
  successReducer(state, result) {
    state.client_money.future_depos = makeAPIPropByTenor(
      result.updated_future_depo_cards
    );
  },
});

appManager.createSocketListener<ReceiveClientCards, AppState>(
  'update_client_cards',
  (state, result) => {
    console.log('update_client_cards: ', result);

    state.client_money.current_loans = makeAPIPropByTenor(result.current_loans);
    state.client_money.past_loans = makeAPIPropByTenor(result.past_loans);
    state.client_money.future_loans = makeAPIPropByTenor(result.future_loans);

    state.client_money.current_depos = makeAPIPropByTenor(result.current_depos);
    state.client_money.past_depos = makeAPIPropByTenor(result.past_depos);
    state.client_money.future_depos = makeAPIPropByTenor(result.future_depos);

    state.client_money.lombard_rate = result.lombard_rate;
  }
);

export const fetchYieldsAdmin = appManager.createApi<
  {
    start_date: string;
    end_date: string;
    freq: number;
  },
  { timestamp: string; yield_13wk: number; yield_10yr: number }[],
  AppState
>('GET_YIELDS', {
  path: '/admin/get_yields_for_client_dealing_planning',
  method: 'POST',
  successReducer(state, result) {
    state.yield_download = { items: result, fetched: true, fetching: false };
  },
});

export const clearYieldsDownload = appManager.createLocalEvent(
  'clear_yields_download',
  state => {
    // const session = state.sessions.items[state.active_session];
    // session.benchmark_preview = undefined;
    state.yield_download = { items: [], fetched: false, fetching: false };
  }
);

export const createClientDealingScenario = appManager.createApi<
  {
    start_date: string;
    end_date: string;
    freq: number;
    players: number;
    aum: number;
    // poolFactor: number;
    // startingLdr: number;
    starting_loans_curve: number;
    starting_depos_curve: number;
    loans_alpha: number;
    loans_gamma: number;
    depos_alpha: number;
    depos_gamma: number;
    initial_loans_pool: number;
    initial_depos_pool: number;
    name: string;
  },
  unknown,
  AppState
>('CREATE_NEW_CLIENT_DEALING_SCENARIO', {
  path: '/admin/create_client_dealing_scenario',
  method: 'POST',
  successReducer(state, result) {
    // state.yield_download = { items: result, fetched: true, fetching: false };
  },
});
